import { fg } from '@atlassian/jira-feature-gating';

const JsmIncidentCommandCenterSuggestedResourcesRelayProvider = {
	get(): boolean {
		return fg('jsm_incident_command_center_suggested_resources');
	},
};

export default JsmIncidentCommandCenterSuggestedResourcesRelayProvider;
